import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import DateRangeSelector from "../Components/filterDataRange/DateRangeSelector";
import userimg from "../Assets/images/user.png";
import ActiveHours from "../Components/Charts/ActiveHours";
import PopEnv from "../Components/Charts/PopEnv";
import Tooltip from "@mui/material/Tooltip";
import GameEng from "../Components/Charts/GameEng";
import {
  AddIcon,
  LeftExtendIcon,
  PenIcon,
  RightExtendIcon,
  LeftArrow,
  RightArrow,
  ExpandDetailsIcon,
  PDFDownloadIcon,
} from "../Assets/iconshere";
import { useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import axios from "axios";
import moment from "moment";
import { exportMultipleChartsToPdf } from "../utils/pdf";
import { humanReadable } from "../utils/useWindowDimensions";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import DateRangeFilter from "./DateRangeFilter";
import { FaTruck } from "react-icons/fa";
import apiClient from "../apiClient";

const MyDashboard = () => {
  var navigate = useNavigate();
  const containerRef = useRef();
  const parentRef = useRef();
  const params = useParams();
  const { uuid } = params;
  const location = useLocation();
  const { state } = location;
  const configData = useSelector((state) => state.configSlice);
  const userData = useSelector((state) => state.userSlice);
  const [filter, setFilter] = useState("all");
  const [eventList, setEventList] = useState([]);
  const [eventDetail, setEventDetail] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isHome, setIsHome] = useState(true);
  const [gameList, setGameList] = useState([]);
  const [dashboardData, setDashboardData] = useState({
    platformVisitCount: 0,
    platformVisit: [],
    totalEvents: 0,
    eventSpentTime: 0,
    sessionSpentTime: 0,
    activeHours: [],
    popularEnvironment: [],
  });

  if (!state) {
    navigate(`/team/dashboard/${userData.user.uuid}`, {
      state: { name: userData.user.name, avatar: userData.user.avatar, uuid: userData.user.uuid },
    });
  }

  useEffect(() => {
    if (!location.state || !location.state.uuid) {
      navigate(`/dashboard/${userData.user.uuid}`, { state: userData.user });
    }
  }, []);

  const scrollAmount = 200;
  const shouldScroll =
    parentRef.current &&
    containerRef.current &&
    (containerRef.current.clientWidth / parentRef.current.clientWidth) * 100 > 95;

  const getDashboardData = async () => {
    setLoading(true);
    try {

      const data = await apiClient.get(`${configData.config.API_URL}/api/dashboard/user/report/${location.state.uuid}/${filter}`, {
        params: {
          applicationId: configData.config.applicationId
        }
      })

      setDashboardData({
        eventSpentTime: data.eventSpentTime,
        sessionSpentTime: data.sessionSpentTime,
        totalEvents: data.totalEvents,
        activeHours: data.activeHours,
        popularEnvironment: data.popularEnvironment,
        platformVisitCount: data.platformVisits.length,
        platformVisit: data.platformVisits,
      });

      setEventDetail(true);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const tableData1 = [
    ["MyDashBoard", ""],
    ["Name", userData?.user?.name],
    ["Events", dashboardData?.totalEvents],
    ["Application visits", dashboardData?.platformVisitCount],
    ["Average Event duration", humanReadable(dashboardData?.eventSpentTime)],
    ["Average Session Time", humanReadable(dashboardData?.sessionSpentTime)],
    ["Report Generated at ", moment().format("ll")],
  ];

  const tableData2 = [
    ["ScoreBoard", ""],
    ["Game Name", "Data 1"],
    ["Game Name", "Data 2"],
    ["Game Name", "Data 3"],
  ];

  const tableData2Heading = [["ScoreBoard"]];

  const getEventList = async () => {
    try {
      const data = await apiClient.get(`${configData.config.API_URL}/api/event/list/ongoing`)

      setEventList(data);
    } catch (error) {
      console.log(error);
    }
  };

  const getGameScoreList = async () => {
    try {

      const data = await apiClient.get(`${configData.config.API_URL}/api/game/user/maximum/score`);

      setGameList(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getEventList();
    getGameScoreList();
    const intervalId = setInterval(getEventList, 60000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (location?.state?.uuid) {
      getDashboardData();
    }
  }, [location, filter]);

  const handleScroll = (scrollDirection) => {
    const container = containerRef.current;
    if (container) {
      const currentScrollLeft = container.scrollLeft;
      if (scrollDirection === "left") {
        container.scrollTo({
          left: currentScrollLeft - scrollAmount,
          behavior: "smooth",
        });
      } else if (scrollDirection === "right") {
        container.scrollTo({
          left: currentScrollLeft + scrollAmount,
          behavior: "smooth",
        });
      }
    }
  };

  const handleMouseScroll = (e) => {
    e.preventDefault();
    const container = containerRef.current;
    const scrollSpeed = 2;
    const currentScrollLeft = container.scrollLeft;
    const newScrollLeft = currentScrollLeft + e.deltaY * scrollSpeed;
    smoothScroll(container, newScrollLeft);
  };

  const smoothScroll = (element, to) => {
    let start = element.scrollLeft;
    let change = to - start;
    let currentTime = 0;
    const increment = 40;
    const duration = 400;

    const animateScroll = () => {
      currentTime += increment;
      let val = Math.easeInOutQuad(currentTime, start, change, duration);
      element.scrollLeft = val;
      if (currentTime < duration) {
        requestAnimationFrame(animateScroll);
      }
    };

    animateScroll();
  };

  Math.easeInOutQuad = function (t, b, c, d) {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  };

  useEffect(() => {
    if (window.location.pathname.startsWith("/team/user/")) {
      setIsHome(false);
    }
  }, []);

  return (
    <div className="container-fluid bg-grey-main dashboard p-3 pt-2">
      <div className="row pb-1">
        <div className="col-md-6 d-flex align-items-center">
          {/* {isHome ?
                        ""
                        : 
                     <button className='backbtn cursor-pointer ps-2 mt-2' title="Back" style={{ fontSize: '16px' }} onClick={() => navigate(-1)}> <FaArrowLeftLong /> Back </button> 
                    */}
        </div>

        <div className="col-md-6 d-flex align-itmes-center justify-content-end">
          <DateRangeSelector selected={filter} setSelected={setFilter} />
          {/* <DateRangeFilter /> */}
          <button
            className="DefaultRedBtn download ms-2"
            onClick={() => exportMultipleChartsToPdf("My_Dashboard", tableData1, tableData2)}
          >
            <PDFDownloadIcon />{" "}
          </button>
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-md-12">
          <div className="datacardesign ">
            <div className="row justify-content-between">
              <div className={isHome ? "col-md-4 " : "col-md-4 d-flex align-items-center "}>
                <div className="cardimages d-flex align-items-center">
                  {isHome ? (
                    <img src={userimg} className="defaultimagesdash" alt="" referrerPolicy={"no-referrer"} />
                  ) : state.avatar ? (
                    <div className="usercardesign m-0 ps-3" style={{ height: "auto" }}>
                      <div className="avatarimg ps-3">
                        <img src={state.avatar} referrerPolicy={"no-referrer"} />
                      </div>
                    </div>
                  ) : (
                    <div className="usercardesign m-0 ps-3" style={{ height: "auto" }}>
                      <div className="initials-placeholder abc">
                        {state?.name
                          ?.split(" ")
                          .map((word) => word[0])
                          .slice(0, 2)
                          .join("")}
                      </div>
                    </div>
                  )}
                  {isHome ? (
                    <div className="welcometext ps-3">
                      {loading ? (
                        <Skeleton width="20vw" />
                      ) : (
                        <>{location?.state?.uuid == userData?.user?.uuid && <p>Welcome back !</p>}</>
                      )}
                      <h4> {loading ? <Skeleton width="25vw" /> : location?.state?.name}</h4>
                    </div>
                  ) : (
                    <div className="welcometext notwelcome ps-3 pt-0 mt-0">
                      <h4> {loading ? <Skeleton width="25vw" /> : location?.state?.name}</h4>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-8">
                <div className="dashstatdata">
                  <div className="welcometext ">
                    <p>{loading ? <Skeleton width="5vw" /> : <> Application Visits </>} </p>
                    {loading ? (
                      <Skeleton width="5vw" />
                    ) : (
                      <span className="d-flex align-items-center justify-content-between gap-3 pt-3">
                        <h4 className="m-0 p-0">{dashboardData?.platformVisitCount}</h4>
                        {dashboardData.platformVisitCount > 0 && (
                          <Tooltip title="View more">
                            <span
                              onClick={() =>
                                navigate(`/user/visits/list/${uuid}?filter=${filter}&type=visits`, {
                                  state: { name: state.name, avatar: state.avatar, data: dashboardData.platformVisit },
                                })
                              }
                              className="enlargebtn"
                            >
                              <ExpandDetailsIcon />
                            </span>
                          </Tooltip>
                        )}
                      </span>
                    )}
                  </div>
                  <div className="welcometext ">
                    <p>{loading ? <Skeleton width="5vw" /> : <> Events </>} </p>
                    {loading ? (
                      <Skeleton width="5vw" />
                    ) : (
                      <span className="d-flex align-items-center justify-content-between gap-3 pt-3">
                        <h4 className="m-0 p-0">{dashboardData.totalEvents}</h4>
                        {dashboardData.totalEvents > 0 && (
                          <Tooltip title="View more">
                            <span
                              onClick={() =>
                                navigate(`/user/eventsList/list/${uuid}?filter=${filter}&type=eventsList`, {
                                  state: { name: state.name, avatar: state.avatar },
                                })
                              }
                              className="enlargebtn"
                            >
                              <ExpandDetailsIcon />
                            </span>
                          </Tooltip>
                        )}
                      </span>
                    )}
                  </div>
                  <div className="welcometext">
                    <p>{loading ? <Skeleton width="5vw" /> : <> Average Event Duration </>}</p>
                    {loading ? (
                      <Skeleton width="5vw" />
                    ) : (
                      <span className="d-flex align-items-center justify-content-between gap-3 pt-3">
                        <h4 className="m-0 p-0">{humanReadable(dashboardData.eventSpentTime)}</h4>
                        {dashboardData.eventSpentTime > 0 && (
                          <Tooltip title="View more">
                            <span
                              onClick={() =>
                                navigate(`/user/eventDuration/list/${uuid}?filter=${filter}&type=eventDuration`, {
                                  state: { name: state.name, avatar: state.avatar },
                                })
                              }
                              className="enlargebtn"
                            >
                              <ExpandDetailsIcon />
                            </span>
                          </Tooltip>
                        )}
                      </span>
                    )}
                  </div>
                  <div className="welcometext">
                    <p>{loading ? <Skeleton width="5vw" /> : <> Average Session Time </>}</p>
                    {loading ? (
                      <Skeleton width="5vw" />
                    ) : (
                      <span className="d-flex align-items-center justify-content-between gap-3 pt-3">
                        <h4 className="m-0 p-0">{humanReadable(dashboardData.sessionSpentTime)}</h4>
                        {dashboardData.sessionSpentTime !== null && (
                          <Tooltip title="View more">
                            <span
                              onClick={() =>
                                navigate(`/user/session/list/${uuid}?filter=${filter}&type=session`, {
                                  state: { name: state.name, avatar: state.avatar },
                                })
                              }
                              className="enlargebtn"
                            >
                              <ExpandDetailsIcon />
                            </span>
                          </Tooltip>
                        )}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-3 pe-0 ">
          <div className="col-md-9">
            <div className="row">
              <div className="col-md-6 custom-chart mx-0 ps-2">
                <div className="graphbox overflow-hidden pb-1 ">
                  {loading ? (
                    <Skeleton width="40%" />
                  ) : (
                    <p>
                      {" "}
                      <> Active Time </>
                    </p>
                  )}
                  {loading ? (
                    <Skeleton count={1} height="35vh" width="100%" />
                  ) : (
                    <>
                      <ActiveHours data={dashboardData.activeHours} />
                    </>
                  )}
                </div>
              </div>
              <div className="col-md-6 mx-0 ps-2">
                <div className="graphbox overflow-hidden pb-1 custom-chart">
                  {loading ? (
                    <Skeleton width="40%" />
                  ) : (
                    <>
                      <p> Popular Environment</p>
                    </>
                  )}
                  {loading ? (
                    <Skeleton count={1} height="35vh" width="100%" />
                  ) : (
                    <div>
                      <PopEnv data={dashboardData.popularEnvironment} />
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-md-12 ps-2">
                <div className="graphbox overflow-hidden ">
                  {loading ? (
                    <Skeleton count={1} height="25vh" width="30%" />
                  ) : (
                    <>
                      {eventList.length > 0 && (
                        <span>
                          {loading ? (
                            <Skeleton width="40%" />
                          ) : (
                            <p>
                              {" "}
                              <> Upcoming Events </>
                            </p>
                          )}

                          <p className="addsome">
                            <Link className="text-danger text-decoration-none" to="/events/create">
                              <AddIcon /> <span> Create Event </span>{" "}
                            </Link>
                          </p>
                        </span>
                      )}

                      {eventList.length > 0 ? (
                        <>
                          <div className="event-list-parent" ref={parentRef}>
                            {shouldScroll && (
                              <div className="scroll-left" onClick={() => handleScroll("left")}>
                                <LeftArrow />
                              </div>
                            )}
                            <div className="eventlists mt-2" onWheel={handleMouseScroll} ref={containerRef}>
                              {eventList.map((event, index) => (
                                <div className="thisevent" key={index + 1}>
                                  <div className="event-info">
                                    <div className="event-detail">
                                      <span className="event-name">{event.name}</span>
                                      <span className="event-date">{moment(event.startTime).format("DD/MM/YYYY")}</span>
                                      <span className="event-date">
                                        {moment(event.startTime).format("LT")} -{moment(event.endTime).format("LT")}
                                      </span>
                                    </div>
                                    <div className="event-users">
                                      <div className="user-list">{event.users.length} Users</div>
                                      <span className="functions">
                                        <span onClick={() => navigate(`/events/${event.uuid}`)} className="classicbtn">
                                          <PenIcon />
                                        </span>
                                        {/* <span className="classicbtn">
                                        <ExtendIcon />
                                      </span> */}
                                      </span>
                                    </div>
                                  </div>

                                  <div className={eventDetail === event.uuid ? "enter-event" : " close-detail"}>
                                    <div className="event-data">{event.description}</div>
                                  </div>

                                  <span
                                    className="switchbtn"
                                    onClick={() => setEventDetail(eventDetail === event.uuid ? null : event.uuid)}
                                  >
                                    {eventDetail === event.uuid ? <RightExtendIcon /> : <LeftExtendIcon />}
                                  </span>
                                </div>
                              ))}
                            </div>

                            {shouldScroll && (
                              <div className="scroll-right" onClick={() => handleScroll("right")}>
                                <RightArrow />
                              </div>
                            )}
                          </div>
                        </>
                      ) : (
                        <div className="no-events">
                          <p>No Upcoming Events Found </p>
                          <Link className="DefaultRedBtn d-inline text-decoration-none" to="/events/create">
                            <AddIcon /> <span> Create Event </span>{" "}
                          </Link>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-3 pe-0 mx-0 ps-2">
            <div className="row">
              <div className="col-md-12 ">
                <div className="graphbox overflow-hidden pb-0 ">
                  {loading ? <Skeleton width="40%" /> : <></>}
                  {loading ? (
                    <Skeleton count={1} height="32.5vh" width="100%" />
                  ) : (
                    <>
                      <div className="custom-chart">
                        <p> Game Engagement </p>
                        <GameEng gameList={gameList} />
                      </div>
                    </>
                  )}
                  <div className="scorestat">
                    {loading ? null : <p> Scoreboard </p>}
                    {loading ? (
                      <Skeleton width="100%" height="31.5vh" className="mt-3" />
                    ) : (
                      <div className="stat-score-list">
                        <>
                          {gameList.map((item, i) => {
                            return (
                              <span key={i + 1}>
                                <p> {item.game} </p>
                                <p> {item.maxScore} </p>
                              </span>
                            );
                          })}
                        </>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyDashboard;
